<template>
  <div class='simple-count-down'>
    <span v-if="timeCountDown.level>=4">{{timeCountDown.days}}天</span>
    <span v-if="timeCountDown.level>=3">{{timeCountDown.hours|formatSingleNumberPreFix0}}:</span>
    <span v-if="timeCountDown.level>=0">{{timeCountDown.minutes|formatSingleNumberPreFix0}}:</span>
    <span v-if="timeCountDown.level>=0">{{timeCountDown.seconds|formatSingleNumberPreFix0}}</span>
  </div>
</template>
<script>
import { patchFormatMillisecond } from '../../common/utils'
export default {
  name: 'secondsCountDown',
  components: {},
  mixins: [],
  props: {
    seconds: { type: Number, default: 0 }
  },
  data: function () {
    return {
      milliseconds: this.seconds * 1000
    }
  },
  computed: {
    timeCountDown () {
      return patchFormatMillisecond(this.milliseconds)
    }
  },
  watch: {
    seconds (val) {
      this.milliseconds = val * 1000 || 0
      this.initTimer()
    }
  },
  created: function () {
    if (this.milliseconds) {
      this.initTimer()
    }
  },
  mounted: function () {},
  beforeDestroy: function () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      console.log('... clear timer')
      this.timer && clearInterval(this.timer)
    },
    initTimer () {
      this.clearTimer()
      // 循环倒计时
      const secondDo = () => {
        console.log('滴答...', this.milliseconds)
        let nextMilliseconds = this.milliseconds - 1000
        nextMilliseconds = nextMilliseconds >= 0 ? nextMilliseconds : 0
        this.milliseconds = nextMilliseconds
        if (nextMilliseconds <= 0) {
          this.clearTimer()
        }
      }
      secondDo()
      this.timer = setInterval(() => {
        secondDo()
      }, 1000)
    }
  },
}
</script>
<style scoped lang='stylus'>

</style>
